import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { NetworkService } from '@app/shared/services/network.service';

@Component({
  selector: 'app-offline',
  templateUrl: './offline.component.html',
  styleUrls: ['./offline.component.scss'],
  standalone: false,
})
export class OfflineErrorComponent implements OnInit, OnDestroy {
  constructor(
    private readonly router: Router,
    private readonly networkService: NetworkService
  ) {}

  titleText = 'Uwaga!';
  messageText = 'Twoje urządzenie nie ma połączenia z internetem.';
  isMobile = environment.appMode;

  tryOneMoreTimeText = 'Spróbuj ponownie';
  backTOShelfText = 'Wróć do półki';

  private subscription?: Subscription;

  ngOnInit(): void {
    this.subscription = this.networkService.isOnlineMode$
      .pipe(filter(Boolean))
      .subscribe(() => this.backClick());
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  async retry(): Promise<void> {
    const { connected } = await this.networkService.refreshStatus();
    if (connected) {
      this.backClick();
    }
  }

  backClick(): void {
    this.router.navigate(['/']);
  }
}
